import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import LeadershipScreen from '@/components/LeadershipScreen';
import TenantAdminUsers from '@/pages/tenantadmin/UsersPage';
import RolesPage from '@/modules/admin-rbac/pages/RolesPage';
import PermissionsPage from '@/modules/admin-rbac/pages/PermissionsPage';
import SpecialisationsPage from '@/modules/admin-rbac/pages/SpecialisationsPage';
import RosterPlannerPage from '@/modules/roster/pages/RosterPlannerPage';
import ReceptionReportsPage from '@/pages/ReceptionReportsPage';
import AuthAuditPage from '@/modules/admin-reports/pages/AuthAuditPage';
import BookingSettingsPage from '@/modules/admin-booking/pages/BookingSettingsPage';
import ReferralApprovalConfigPage from '@/modules/referral/pages/ReferralApprovalConfigPage';
import ReferralApprovalInboxPage from '@/modules/referral/pages/ReferralApprovalInboxPage';

const LEAD = ['management', 'admin', 'super_admin', 'fic'];

function gate(perms, page) {
  return (
    <ProtectedRoute allowedRoles={LEAD} anyPermission={perms}>
      <LeadershipScreen>{page}</LeadershipScreen>
    </ProtectedRoute>
  );
}

/** FIC screens that share LeadershipChrome (no clinic-admin sidebar). */
export function managementAdminRoutes() {
  return (
    <>
      <Route path="/management/auth-audit" element={gate(['audit.auth.view'], <AuthAuditPage />)} />
      <Route path="/management/users" element={gate(['admin.users'], <TenantAdminUsers />)} />
      <Route path="/management/roles" element={gate(['admin.roles'], <RolesPage />)} />
      <Route path="/management/permissions" element={gate(['admin.permissions'], <PermissionsPage />)} />
      <Route path="/management/specialisations" element={gate(['admin.specialisations'], <SpecialisationsPage />)} />
      <Route path="/management/roster" element={gate(['roster.manage', 'roster.view'], <RosterPlannerPage />)} />
      <Route path="/management/referral-inbox" element={gate(['management.view'], <ReferralApprovalInboxPage />)} />
      <Route path="/management/referral-config" element={gate(['admin.booking_settings'], <ReferralApprovalConfigPage />)} />
      <Route path="/management/booking-settings" element={gate(['admin.booking_settings'], <BookingSettingsPage />)} />
      <Route path="/management/visit-reports" element={gate(['reports.view'], <ReceptionReportsPage />)} />
    </>
  );
}
